module.exports = "<!-- <p>\n  Хой <mat-icon *ngIf=\"(showDialog$ |async)\" color=\"accent\" class=\"icon-disp\"> highlight_off </mat-icon>\n</p> -->\n"